import { FC, ReactNode, Children } from "react";
import { styled } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { useSection } from "lib/context/section";

type Props = {
  children?: ReactNode;
};

const Wizard: FC<Props> = ({ children }) => {
  const { sectionId } = useSection();
  const childrenArray = Children.toArray(children);
  const currentChild = childrenArray[sectionId];
  return <CardContentStyled>{currentChild}</CardContentStyled>;
};

export default Wizard;

const CardContentStyled = styled(CardContent)`
  //min-height: 40vw;
`;
